import type { ItineraryDay } from '../../../types';

/** A day's calendar date, read as written: `new Date(iso)` would shift it a day west of UTC. */
export function dayKey(day: Pick<ItineraryDay, 'date'>): string {
  return day.date.slice(0, 10);
}

/**
 * The day the meals tab opens on: today, and only today. Outside the trip
 * every day starts folded — opening day 1 "because it is next" was noise.
 */
export function dayToOpen(days: ItineraryDay[], today: string): string | null {
  return days.find(d => dayKey(d) === today)?.id ?? null;
}
